import i18n from "shared/i18n";

const validate = (value) => {
  let errors = null;
  if (!value) {
    errors = { text: i18n.t("Please add your Short Username") };
  }
  if (value) {
    if (value.length < 3) {
      errors = { text: i18n.t("Short Username must be longer than 2 characters") };
    }
  }
  return errors;
};

export default validate;
